import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError, map, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AlertService } from 'src/app/shared/services/alert.service';
import { Router } from '@angular/router';
import { EstatPacient, PacientModel } from '../models/gitih.model';
import { AuthService } from '../../auth/auth.service'
import { formatNumber } from '@angular/common';
import moment from 'moment';

export enum Element {
  PACIENTS = 'pacients',
  PERFILS = 'perfils',
  CAPACITATS = 'capacitats'
}

@Injectable({
  providedIn: 'root'
})
export class GitihService {

  private url: string = environment.urlAPI;

  constructor(
    private http: HttpClient,
    private alertService: AlertService,
    private router: Router,
    private auth: AuthService) {

  }

  /**
   * Comprova quina ha estat la última actualització de dades
   * @returns 
   */
  public miraUltimaActualitzacio() {
    if (!this.auth.estaAutenticat()) {
      return;
    }
    return this.http.get(`${this.url}/pacients/actualitzats`)
    .pipe(
      map((resp: any) => {
        return resp;
      }),
      catchError(error => {
        return this.miraError(error)
      })
    );
  }

  // ------------------------------------------ CRUD
  public llista(element) {
    return this.http.get(`${this.url}/${element}`)
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError(error => {
          return this.miraError(error)
        })
      );
  }

  public cerca(element, id: string) {
    return this.http.get(`${this.url}/${element}/${id}`)
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError(error => {
          return this.miraError(error)
        })
      );
  }

  public nou(element: string, dades: any) {
    return this.http.post(`${this.url}/${element}`, dades)
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError(error => {
          return this.miraError(error)
        })
      );
  }

  public mod(element: string, dades: any) {
    return this.http.put(`${this.url}/${element}/${dades.id}`, dades)
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError(error => {
          return this.miraError(error)
        })
      );
  }

  public borra(element: string, dades: any) {
    console.log("esborrar " + element + ": " + dades.id);
    return this.http.delete(`${this.url}/${element}/${dades.id}`)
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError(error => {
          return this.miraError(error)
        })
      );
  }

  // ------------------------------------------ SERVEIS ESPECIFICS
  public cercaCapacitatsXPerfil(idPerfil: string) {
    return this.http.get(`${this.url}/perfil/${idPerfil}`)
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError(error => {
          return this.miraError(error)
        })
      );
  }

  // torna la llista de pacients actual. Encara que faig servir CRUD, 
  // separo la funció per filtrar els NO PRESENTS
  public llistaPacients(historic:boolean, inici:Date = null, final:Date = null) {
    let pInici:string;
    let pFinal:string;
    if (historic) {
      if (!inici) {
        inici = new Date();
      }
      if (!final) {
        final = new Date();
      }
      pInici = moment(inici).hour(0).minute(0).second(0).toISOString();
      pFinal = moment(final).hour(23).minute(59).second(59).toISOString();
    }
    const ruta = historic?`pacients/historic/${pInici}/${pFinal}`:'pacients';
    console.log(ruta);
    return this.http.get(`${this.url}/${ruta}`)
      .pipe(
        map((resp: any) => {
          return resp;
          // if (this.auth.esAdmin()) {
          //   return resp;
          // }
          // else {
          //   return resp.filter(r => r.present);
          // }
        }),
        catchError(error => {
          return this.miraError(error)
        })
      );
  }

  /**
   * Envía dades modificables del pacient
   * @param pacient objecte pacient
   * @returns pacient amb l'estat modificat
   */
  public desarDadesPacient(pacient: PacientModel) {
    pacient.icam.estat = pacient.icam.estat==EstatPacient.Nou?EstatPacient.Pendent:pacient.icam.estat
    let dades = {
      "empresa" : pacient.icam.empresa,
      "cno" : pacient.icam.cno,
      "llocTreball" : pacient.icam.llocTreball,
      "codiSituacioLaboral" : pacient.icam.codiSituacioLaboral,
      "dataEfectes": this.formatData(pacient.icam.dataEfectes),
      "codiIndicadorMalaltia" : pacient.icam.codiIndicadorMalaltia,
      "observacions" : pacient.icam.observacions,
      "estat" : pacient.icam.estat,
      "diagnostic" : pacient.icam.diagnostic,
      "dataPart": this.formatData(pacient.icam.dataPart)
    }
    return this.http.put(`${this.url}/pacients/modificaPacient/${pacient.pacient.id}`, dades)
      .pipe(
        tap((resp: any) => {
          return resp;
        }),
        catchError(error => {
          return this.miraError(error)
        })
      );
  }

  /**
   * Demana l'actualització de la llista de pacients
   * @param act : true: torna a demanar dades del servei; false: només porta les dades que hi hagi a la bd GITIH
   * @returns llista de pacients
   */
  public actualitzaPacients() {
    // demana l'actualització al servidor, però no torna dades
    return this.http.get(`${this.url}/pacients/actualitzaPacients`)
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError(error => {
          throw this.miraError(error)
        })
      );
  }

  /**
   * Actualitza les dades d'un pacient concret. 
   * @param id identificador del pacient
   * @returns 
   */
  public actualitzaPacient(id:string) {
    console.log("demana actualització");
    return this.http.get(`${this.url}/pacients/actualitzaPacient/${id}`)
      .pipe(
        map((resp: any) => {          
          console.log("torna actualització");
          return resp;
        }),
        catchError(error => {
          console.error("error actualització");
          throw this.miraError(error)
        })
      );
  }

  /**
   * Envia el rebuig de la IT
   * @param pacient estructura de pacient. Només l'id i dades ICAM
   * @returns 
   */
  rebutjarIT(pacient) {
    let dades = {
      "id" : pacient.pacient.id,
      "icam": {
        "codiSituacioLaboral": pacient.icam.codiSituacioLaboral,
        "empresa" : pacient.icam.empresa,
        "cno" : pacient.icam.cno,
        "llocTreball" : pacient.icam.llocTreball,
        "dataEfectes" : pacient.icam.dataEfectes,
        "codiIndicadorMalaltia" : pacient.icam.codiIndicadorMalaltia,
        "observacions" : pacient.icam.observacions,
        "diagnostic" : pacient.icam.diagnostic,
        "estat": pacient.icam.estat,
        "motiuEstat": pacient.icam.motiuEstat,
      }
    }
    return this.http.put(`${this.url}/pacients/${pacient.pacient.id}`, dades)
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError(error => {
          throw this.miraError(error)
        })
      );
  }

  duradaIT(pacient) {
    const url = `${this.url}/pacients/duradaIT/${pacient.pacient.id}/${pacient.icam.cno?pacient.icam.cno:0}`
    console.log(url)
    return this.http.get(url)
      .pipe(
        map((resp: any) => {
          console.log(resp);
          return resp;
        }),
        catchError(error => {
          console.error(error.message);
          throw this.miraError(error)
        })
      );
  }

  comunicaIT(pacient) {
    let dades = {
      "id" : pacient.pacient.id,
      "icam": {
        "codiSituacioLaboral": pacient.icam.codiSituacioLaboral,
        "empresa" : pacient.icam.empresa,
        "cno" : pacient.icam.cno,
        "llocTreball" : pacient.icam.llocTreball,
        "dataEfectes" : this.formatData(pacient.icam.dataEfectes),
        "codiIndicadorMalaltia" : pacient.icam.codiIndicadorMalaltia,
        "observacions" : pacient.icam.observacions,
        "diagnostic" : pacient.icam.diagnostic,
      }
    }
    // "dataEfectes" : this.formatData(pacient.icam.dataEfectes),
    console.log(dades);
    return this.http.put(`${this.url}/pacients/comunicaIT`, dades)
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError(error => {
          console.error(JSON.stringify(error));
          throw this.miraError(error)
        })
      );
  }

  anulaIT(pacient) {
    let dades = {
      "id" : pacient.pacient.id,
      "icam": {
        "observacions" : pacient.icam.observacions,
      }
    }
    console.log(dades);
    return this.http.put(`${this.url}/pacients/anulaIT`, dades)
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError(error => {
          console.error(error.message);
          throw this.miraError(error)
        })
      );
  }

  comunicaAltaIT(pacient) {
    let dades = {
      "id": pacient.id,
      "part": this.formatData(pacient.icam.dataPart)
    }
    console.log(dades);
    return this.http.put(`${this.url}/pacients/comunicaAltaIT`, dades)
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError(error => {
          console.error(JSON.stringify(error));
          throw this.miraError(error)
        })
      );
  }

  enviaDocumentIT(id, mail) {
    return this.http.get(`${this.url}/pacients/documentITmail/${id}/${mail}`)
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError(error => {
          console.error(error.message);
          throw this.miraError(error)
        })
      );
  }

  // ----------------------------------------------------- funcions de suport
  private miraError(error: any) {
    let text = '';
    if (error instanceof HttpErrorResponse) {
      if (error.error instanceof ErrorEvent) {
        console.error("Error Event");
        text = JSON.stringify(error);
        this.alertService.error(JSON.stringify(error));
      } else {
        text = this.getErrorText(error);
        switch (error.status) {
          case 404:      //not found
            console.error("no trobat");
            break;
          case 401:      //login
          case 403:     //forbidden              
            this.alertService.error(text);
            this.auth.logout();
            // this.router.navigateByUrl("auth/login");
            break;
          case 406:     //not acceptable
            this.alertService.error(text);
            break;
          default:
            this.alertService.error(text);
            this.auth.logout();
            // this.router.navigateByUrl("auth/login");
        }
      }
    } else {
      console.error("Error no controlat.");
    }
    return text;
  }

  private getErrorText(error) {
    let missatge = `[${error.status} ${error.statusText}] `;
    if (error.error) {
      if (error.error.message) {
        missatge += error.error.message
      }
      else
      {
        missatge += JSON.stringify(error.error);
      }
    }
    else {
      if (error.message) {
        missatge += error.message;
      }
      else {
        missatge += JSON.stringify(error);
      }
    }
    return missatge;
  }

  private formatData(d:Date) {
    if (!d || d==undefined) {
      d = new Date();
    }
    if(typeof(d)=='string') {
      d = new Date(d);
    }
    if (Number.isNaN(d.getFullYear())) {
      d = new Date();
    }
    return d.getFullYear() + "-" + formatNumber(d.getMonth() + 1, 'ca', '2.0-0') + "-" + formatNumber(d.getDate(),'ca','2.0-0') + 'T00:00:00.000Z';
    
  }

  getVersion() {
    const url = this.url + '/version';
    return this.http.get(url);
  }

  getCookie(name: string) {
    let ca: Array<string> = document.cookie.split(';');
    let caLen: number = ca.length;
    let cookieName = `${name}=`;
    let c: string;

    for (let i: number = 0; i < caLen; i += 1) {
        c = ca[i].replace(/^\s+/g, '');
        if (c.indexOf(cookieName) == 0) {
            return c.substring(cookieName.length, c.length);
        }
    }
    return '';
  }

  setCookie(name: string, value: string, expireDays: number, path: string = '') {
    let d:Date = new Date();
    d.setTime(d.getTime() + expireDays * 24 * 60 * 60 * 1000);
    let expires:string = `expires=${d.toUTCString()}`;
    let cpath:string = path ? `; path=${path}` : '';
    document.cookie = `${name}=${value}; ${expires}${cpath}`;
  }

}
